export class BaseService {
  constructor($api) {
    this.api = $api
  }
}
